import { checkAuthentication } from './middleware';

export const workspaceRoutes = [
    {
        path: '/workspace/:tab?/typist',
        name: 'WorkspaceTypist',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceTypist'),
        beforeEnter: checkAuthentication,
        props: true
    },
    {
        path: '/workspace/:tab?/qa',
        name: 'WorkspaceQA',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceQA'),
        beforeEnter: checkAuthentication,
        props: true

    },
    {
        path: '/workspace/ppp',
        name: 'WorkspaceVendor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceVendor'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/workspace/auditor',
        name: 'WorkspaceAuditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceAuditor'),
        beforeEnter: checkAuthentication,
    },
    {
        path: '/workspace/uploader',
        name: 'WorkspaceUploader',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceUploader'),
        beforeEnter: checkAuthentication,
    },
    {
        path: '/workspace/:tab?/editor',
        name: 'WorkspaceEditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceEditor'),
        beforeEnter: checkAuthentication,
        props: true
    },
    {
        path: '/workspace/:tab?/auditor-qa',
        name: 'WorkspaceAudit',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceAudit'),
        beforeEnter: checkAuthentication,
        props: true
    },
    {
        path: '/qass/savedlist',
        name: 'SavedList',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/qass/SavedList'),
        beforeEnter: checkAuthentication,
    },
    {
        path: '/workspace/typist/:tab?/:id',
        name: 'Workspace',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/Workspace'),
        beforeEnter: checkAuthentication,
        props: true,
    },
    {
        path: '/workspace/audit/:id/:type/:tab',
        name: 'WorkspaceForAuditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceForAuditor'),
        beforeEnter: checkAuthentication,
        props: true,
    },
    {
        path: '/workspace/master-auditor',
        name: 'WorkspaceMasterAuditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceMasterAuditor'),
        beforeEnter: checkAuthentication,
    },
    {
        path: '/workspace/master-auditor/:id/:type',
        name: 'WorkspaceForMasterAuditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceForMasterAuditor'),
        beforeEnter: checkAuthentication,
        props: true,
    },
        {
        path: '/workspace/edit/:tab?/:id',
        name: 'WorkspaceForEditor',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceForEditor'),
        beforeEnter: checkAuthentication,
        props: true,
    },
    {
        path: '/workspace/qa/:tab?/:id',
        name: 'WorkspaceForQA',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceForQA'),
        beforeEnter: checkAuthentication,
        props: true,
    },
    {
        path: '/workspace/audit-qa/:tab?/:id',
        name: 'WorkspaceForAuditQA',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/WorkspaceForAuditQA'),
        beforeEnter: checkAuthentication,
        props: true,
    },
    {
        path: '/workspace/validate/:id',
        name: 'ValidateWorkspace',
        component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/workspace/ValidateWorkspace'),
        beforeEnter: checkAuthentication,
        props: true,
    },

]